module.exports = __webpack_public_path__ + "img/eye-doctor.92ca00d0.png";